import { createSelector } from "reselect";
import get from "lodash.get";

const authEntitySelector = (state: TReduxState) => state?.root.entities?.auth;

export const getLoggedInUser = createSelector(authEntitySelector, (appData) =>
  get(appData, "data", null),
);

export const getCurrentUserRole = createSelector(getLoggedInUser, (user) =>
  get(user, "role", -1),
);

export const getPasswordRecoverEmail = createSelector(
  authEntitySelector,
  (token) => token.givenEmailForPasswordRecovery,
);

export const getTourGuidesLoading = createSelector(
  authEntitySelector,
  (auth) => !!get(auth, "tourGuidesLoading", false),
);
